(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    function applyExpandedSwatches() {
    document.querySelectorAll('variant-picker').forEach(function (root) {
      if (!root.__expandedSwatchOptions) return;
      root.__expandedSwatchOptions.forEach(function (optionName) {
        var fieldset = root.querySelector('fieldset[data-option-name="' + CSS.escape(optionName) + '"]');
        if (!fieldset) return;

        var toggle = fieldset.querySelector('[data-swatch-toggle]');
        if (toggle) {
          toggle.classList.add('is-expanded');
          toggle.setAttribute('aria-expanded', 'true');
        }

        fieldset.querySelectorAll('[data-swatch-overflow="true"]').forEach(function (label) {
          label.style.setProperty('display', 'flex', 'important');
        });
      });
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-swatch-toggle]');
    if (!toggle) return;

    var fieldset = toggle.closest('fieldset');
    var root = toggle.closest('variant-picker');
    if (!fieldset || !root) return;

    if (!root.__expandedSwatchOptions) {
      root.__expandedSwatchOptions = new Set();
    }

    var optionName = fieldset.getAttribute('data-option-name');
    var expanded = toggle.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    if (expanded) {
      root.__expandedSwatchOptions.add(optionName);
    } else {
      root.__expandedSwatchOptions.delete(optionName);
    }

    fieldset.querySelectorAll('[data-swatch-overflow="true"]').forEach(function (label) {
      label.style.setProperty('display', expanded ? 'flex' : 'none', 'important');
    });
  });

  // Nach jeder DOM-Aktualisierung (z. B. wenn die Variantenauswahl die Sektion
  // per JS neu rendert) den zuvor aufgeklappten Zustand wiederherstellen.
  new MutationObserver(applyExpandedSwatches).observe(document.body, {
    childList: true,
    subtree: true,
  });
  } catch(e) { console.error(e); }
})();

})();
